import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import CookieConsent from "./components/feature/CookieConsent";
import FloatingButtons from "./components/feature/FloatingButtons";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Header />
      <AppRoutes />
      <Footer />
      <CookieConsent />
      <FloatingButtons />
    </BrowserRouter>
  );
}

export default App;
